import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Normalize old prefixed URLs like /prompt-creator-admin#/dashboard to /#/dashboard.
if (window.location.pathname !== '/') {
  const nextHash = window.location.hash || '#/dashboard';
  window.history.replaceState(null, '', `/${nextHash}`);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
